import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: 'border-box',
    '& ul': {
      margin: 0,
      padding: 0,
    },
  },
  section: { marginBottom: '1em' },
  title: {
    fontSize: 16,
    color: '#1d4065',
    fontWeight: 'bold',
    marginBottom: 15,
    marginInlineStart: theme.spacing(2),
  },
  copyIcon: {
    height: 10,
    width: 10,
    fontSize: 15,
    marginInlineStart: theme.spacing(1),
  },
  list: {
    border: `1px solid #e5e6e7`,
    borderRadius: 5,
    margin: 0,
  },
  info: {
    backgroundColor: '#eef1f5',
    border: 'solid 1px rgba(109, 114, 120, 0.18)',
    borderRadius: 4,
    padding: theme.spacing(1.5),
  },
  detail: {
    padding: theme.spacing(1),
  },
  detailTitle: {
    fontSize: 12,
    color: '#546e7a',
  },
  detailValue: {
    fontSize: 14,
    color: '#003a52',
    marginBottom: theme.spacing(0.5),
  },
  titleBox: {
    background: '#eef1f5',
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    boxSizing: 'border-box',
    marginBottom: 0,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  titleArrow: {
    color: '#b9c3ca',
    fontSize: 20,
  },
  priceLabel: {
    paddingLeft: 10,
    display: 'inline-block',
  },
}));
